import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import styles from './index.module.scss'
import { commaDeliminate } from '../../utilities/stringUtilities'
import DiscountAndTaxFormFields from '../discount-and-tax-form-fields'

export default function DiscountAndTaxSection ({
  values,
  form,
  ticketFeeTotal,
  hasTicketFees,
  total,
  hasInvoiceDiscount,
  hasInvoiceTax,
  showDiscountAndTax,
  isConnectedToQB,
  usingAST,
  taxCodes,
  EditInvoiceLink,
  handleOnChangeDiscountAmount,
  handleOnChangeDiscountPercent,
  handleOnChangeTaxAmount,
  handleOnChangeTaxPercent,
  handleOnChangeTaxCode,
  removeDiscount,
  removeTax,
  isRecurring,
  asset
}) {
  const discountAmount = values?.discountAndTax?.discountAmount || 0

  return (
    <div className={cn(styles.discountAndTaxesContainer, { [styles.discountAndTaxesContainerRecurring]: isRecurring })}>
      {hasInvoiceDiscount
        ? (
          <div className={styles.invoiceMessaging}>
            A discount has been added at the invoice level, so discounts can only be updated on the
            <EditInvoiceLink />.
          </div>
          )
        : (
          <>
            {!values.showDiscountForm && hasTicketFees && showDiscountAndTax && (
              <button
                type='button'
                onClick={() => asset ? form.change(`${asset}.showDiscountForm`, true) : form.change('showDiscountForm', true)}
                className={`${styles.displayFormButton} ${styles.discountAndTaxesButton}`}>
                + Add Discount
              </button>
            )}

            <DiscountAndTaxFormFields
              handleOnChangeAmount={handleOnChangeDiscountAmount}
              handleOnChangePercent={handleOnChangeDiscountPercent}
              remove={() => removeDiscount(form)}
              ticketFeeTotal={ticketFeeTotal}
              type='discount'
              form={form}
              show={values.showDiscountForm}
              isConnectedToQB={isConnectedToQB}
              asset={asset}
            />
          </>
          )}

      {hasTicketFees && showDiscountAndTax && (
        <div
          className={cn(styles.totalContainer, styles.subtotal, {
            [styles.showDiscountAndTaxTotal]: !isRecurring
          })}>
          <div>Subtotal</div>
          <div>
            ${commaDeliminate(ticketFeeTotal - parseFloat(discountAmount))}
          </div>
        </div>
      )}

      {hasInvoiceTax
        ? (
          <div className={styles.invoiceMessaging}>
            A tax has been added at the invoice level, so taxes can only be updated on the
            <EditInvoiceLink />.
          </div>
          )
        : (
          <>
            {!values.showTaxForm && hasTicketFees && showDiscountAndTax && (
              <button
                type='button'
                onClick={() => asset ? form.change(`${asset}.showTaxForm`, true) : form.change('showTaxForm', true)}
                className={cn(styles.displayFormButton, styles.discountAndTaxesButton)}>
                + Add Tax
              </button>
            )}

            <DiscountAndTaxFormFields
              handleOnChangeAmount={handleOnChangeTaxAmount}
              handleOnChangePercent={handleOnChangeTaxPercent}
              handleOnChangeTaxCode={handleOnChangeTaxCode}
              remove={() => removeTax(form)}
              ticketFeeTotal={ticketFeeTotal}
              type='tax'
              form={form}
              show={values.showTaxForm}
              isConnectedToQB={isConnectedToQB}
              usingAST={usingAST}
              taxCodes={taxCodes}
              asset={asset}
            />
          </>
          )}

      {hasTicketFees && (
        <div
          className={cn(styles.totalContainer, styles.total, {
            [styles.showDiscountAndTaxTotal]: showDiscountAndTax && !isRecurring
          })}>
          <div>Total</div>
          <div>
            ${commaDeliminate(total <= 0 ? 0 : total)}
          </div>
        </div>
      )}
    </div>
  )
}

DiscountAndTaxSection.propTypes = {
  values: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  ticketFeeTotal: PropTypes.number.isRequired,
  hasTicketFees: PropTypes.bool.isRequired,
  total: PropTypes.number.isRequired,
  hasInvoiceDiscount: PropTypes.bool.isRequired,
  hasInvoiceTax: PropTypes.bool.isRequired,
  showDiscountAndTax: PropTypes.bool.isRequired,
  isConnectedToQB: PropTypes.bool.isRequired,
  usingAST: PropTypes.bool,
  taxCodes: PropTypes.array,
  EditInvoiceLink: PropTypes.func,
  handleOnChangeDiscountAmount: PropTypes.func.isRequired,
  handleOnChangeDiscountPercent: PropTypes.func.isRequired,
  handleOnChangeTaxAmount: PropTypes.func.isRequired,
  handleOnChangeTaxPercent: PropTypes.func.isRequired,
  handleOnChangeTaxCode: PropTypes.func.isRequired,
  removeDiscount: PropTypes.func.isRequired,
  removeTax: PropTypes.func.isRequired,
  isRecurring: PropTypes.bool,
  asset: PropTypes.string
}
